import { CLEAR_CACHE } from '../types';
import { API_APPLICATIONS_LOADED, API_APPLICATION_UPDATED, API_APPLICATION_VERSIONS_LOADED, API_APPLICATION_DEPLOYED, ApplicationActionTypes, API_APPLICATION_REMOVED, ApplicationState } from './types';

const InitialState: ApplicationState = {
    application: null,
    applications: [],
    versions: [],
    isLoaded: false,
};

export default function ApplicationReducer(state: ApplicationState = InitialState, action: ApplicationActionTypes): ApplicationState {

    switch (action.type) {
        case API_APPLICATIONS_LOADED:
            return {
                ...state,
                applications: action.applications,
                isLoaded: true
            };
        case API_APPLICATION_UPDATED:
            return {
                ...state,
                application: {
                    ...state.application,
                    ...action.application
                }
            };
        case API_APPLICATION_VERSIONS_LOADED:
            return {
                ...state,
                versions: action.versions
            };
        case API_APPLICATION_DEPLOYED:
            return {
                ...state
            };
        case API_APPLICATION_REMOVED:
            return {
                ...state,
                applications: state.applications.filter(app => app.id !== action.applicationId)
            };
        case CLEAR_CACHE:
            return InitialState;
        default:
            return state;
    }
}
